var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_171",
    "data-name": "Grupo 171",
    transform: "translate(-599 -211.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_2",
    "data-name": "Elipse 2",
    transform: "translate(599 211.995)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 59.5,
    r: 59.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 59.5,
    r: 59,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1071",
    "data-name": "Trazado 1071",
    d: "M92.388,70.959a45.271,45.271,0,0,1-9.3-4.626C80.44,64.5,77.691,62.8,75,61a1.732,1.732,0,0,1-.762-.983,3.9,3.9,0,0,0-2.722-3.178c-1.505-.579-3.064-1.009-4.56-1.6a1.61,1.61,0,0,1-.84-1.062,6.2,6.2,0,0,1,.718-3.932,38.35,38.35,0,0,0,3.921-12.789,1.326,1.326,0,0,1,1.112-1.378,2.051,2.051,0,0,0,1.208-.878,9.468,9.468,0,0,0,1.19-6.776,2.154,2.154,0,0,0-.6-1.15,1.864,1.864,0,0,1-.481-2.256c.088-.281.105-.579.166-.869.586-3.02.044-6.013-.254-9.006-.6-6.065-3.484-10.516-9.217-12.912A33.809,33.809,0,0,0,54.8.14,19.039,19.039,0,0,0,33.288,17.686a29.092,29.092,0,0,0,.63,9.208c-1.646.781-1.724,2.221-1.365,3.608.534,2.054,1.287,4.047,2,6.048a1.165,1.165,0,0,0,.8.641c.656.026.726.4.867.9.788,2.668,1.514,5.363,2.468,7.979.753,2.063,1.829,4.011,2.687,6.039a10.949,10.949,0,0,1,.56,2.335c.105.632-.271.834-.858,1.009q-3.1.922-6.127,2.054a1.482,1.482,0,0,0-.788,1.106,2.788,2.788,0,0,1-2.048,2.967,6.893,6.893,0,0,0-.963.535c-2.678,1.6-5.436,3.081-8.009,4.837a40.311,40.311,0,0,1-7.389,3.482s16.428,15.077,39.034,15S94.112,71.641,92.388,70.959Z",
    transform: "translate(603.665 245.563)",
    fill: "#314164"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfil);
export default __webpack_public_path__ + "static/media/perfil.b2903a51ce9b35ae4b01d928ed726def.svg";
export { ForwardRef as ReactComponent };